import React from "react";
import Link from "../Link";
import { FEATURED_BROKERS, INTEGRATIONS_PATH } from "../../content/brokers";
import BrokerLogo from "./BrokerLogo";

function BrokerSet({ copy, inert }) {
  return (
    <ul
      className="broker-scroll__set"
      aria-hidden={inert ? "true" : undefined}
      aria-label={inert ? undefined : "Featured brokerage connections"}
    >
      {FEATURED_BROKERS.map((broker) => (
        <li key={`${copy}-${broker.id}`}>
          <div className="flex w-[5.75rem] flex-col items-center gap-2">
            <BrokerLogo broker={broker} />
            <span className="w-full text-center text-[11px] font-medium leading-tight text-ink/80">
              {broker.shortName || broker.name}
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default function BrokerConnectionsStrip() {
  return (
    <div className="mt-12 md:mt-14">
      <p className="text-center text-[11px] font-semibold uppercase tracking-[0.22em] text-muted">
        Connect your brokerage
      </p>
      <p className="mx-auto mt-2 max-w-lg text-center text-sm leading-relaxed text-muted">
        Attach a supported account to bring holdings into the same view as your strategies.
      </p>

      <div className="broker-scroll relative mt-6">
        <div className="broker-scroll__lane">
          <BrokerSet copy="a" />
          <BrokerSet copy="b" inert />
        </div>
      </div>

      <div className="mt-5 text-center">
        <Link
          to={INTEGRATIONS_PATH}
          className="inline-flex text-sm font-medium text-hint-deep hover:underline"
        >
          See all integrations ↗
        </Link>
      </div>
    </div>
  );
}
